/*
  This loader is aimed to be used inside a flex container.
  It will take all the available space inside this container (flex:1) and display its content (the spinner and the text) centered
*/
import { Spin } from "antd";
import styled from "styled-components";

const LoaderContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.type === "absolute" &&
    `
    position:absolute;
    top:0;
    left:0;
    height:100%;
    width:100%;
  `};
`;

const Loader = ({ size, text, type }) => (
  <LoaderContainer type={type}>
    <div style={{ textAlign: "center" }}>
      <Spin size={size} />
      <div>{text}</div>
    </div>
  </LoaderContainer>
);

export default Loader;
